module.exports = __webpack_public_path__ + "img/c07_unitraider_Normal_ua.34f9cf12.webp";